<script>
  export default {
    mounted() {
      document.addEventListener("keydown", this.handleKeyDown)
    },
    beforeDestroy() {
      document.removeEventListener("keydown", this.handleKeyDown)
    },
    methods: {
      handleKeyDown(event) {
        if (event.key === "Escape") {
          this.close()
        }
      },
      close() {
        this.$emit("close")
      },
    },
  }
</script>

<template>
  <div>
    <div class="flex flex-col px-4 pt-5 pb-4 space-y-4 bg-white sm:p-4 sm:pb-1">
      <img
        class="w-40"
        src="@/core/assets/images/logo_sc_mobi_novo.png"
        alt="SCmobi"
      >

      <div class="p-3 space-y-3 border rounded-md bg-yellow-50 border-yellow-300">
        <p class="text-sm font-medium text-yellow-800">
          🚨 Aviso Importante – Indisponibilidade Programada do SCmobi
        </p>

        <div class="space-y-2 text-sm text-gray-800">
          <p>
            Informamos que o sistema <strong>SCmobi</strong> ficará indisponível em
            alguns momentos para realização de manutenção no banco de dados, conforme
            o cronograma abaixo:
          </p>

          <div class="pl-4">
            <p>
              <strong>13/07 (Segunda-feira)</strong> – Das <strong>20:00h às 22:00h</strong>
              (2 horas de parada)
            </p>
            <p>
              <strong>Sistema:</strong> SCmobi (Parte 1)
            </p>
            <p>
              <strong>Motivo:</strong> Manutenção no banco de dados.
            </p>
          </div>

          <div class="pl-4 pt-2">
            <p>
              <strong>14/07 (Terça-feira)</strong> – Das <strong>20:00h às 22:00h</strong>
              (2 horas de parada)
            </p>
            <p>
              <strong>Sistema:</strong> SCmobi (Parte 2)
            </p>
            <p>
              <strong>Motivo:</strong> Manutenção no banco de dados.
            </p>
          </div>

          <p class="font-semibold text-red-700">
            ⚠️ Durante os períodos informados, o sistema SCmobi poderá ficar total ou
            parcialmente indisponível.
          </p>
        </div>
      </div>
    </div>

    <div
      class="px-4 py-3 bg-gray-100 sm:px-6 sm:flex sm:flex-col sm:items-center"
    >
      <span class="flex w-full mt-3 rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          @click="close"
          type="button"
          class="inline-flex justify-center w-full px-4 py-2 text-xs font-medium leading-normal uppercase transition duration-150 ease-in-out rounded-md shadow-sm btn-blue focus:outline-none sm:leading-tight"
        >
          Fechar
        </button>
      </span>
    </div>
  </div>
</template>